
import { required } from 'vuelidate/lib/validators'

export default {
  rent: {
    tower_id: {
      required
    },
    car_id: {
      required
    },
    unit_id: {
      required
    },
    garage_id: {
      required
    },
    date_go_in: {
      required
    },
    date_go_out: {
      required
    },
    status: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/rent-parking/form/resources/validations.js